import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "info-box" }
const _hoisted_2 = { class: "slider-container" }
const _hoisted_3 = { class: "result-test d-flex justify-content-center align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "image-result-container d-flex justify-content-center align-items-center" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_share_result_button = _resolveComponent("share-result-button")!
  const _component_agile = _resolveComponent("agile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_agile, {
        mobileFirst: "",
        infinite: false,
        dots: false,
        navButtons: false,
        unagile: false,
        onAfterChange: _ctx.changeSlide
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["slide result-test-slide d-flex", { selected: _ctx.currentSlide == 0 }])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.resultInfos.title), 1),
                _hoisted_4,
                _createElementVNode("span", null, _toDisplayString(_ctx.resultInfos.subtitle), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: _ctx.resultInfos.imageResult,
                class: _normalizeClass(["floating-image", _ctx.resultInfos.class])
              }, null, 10, _hoisted_6)
            ]),
            (_ctx.patient.name)
              ? (_openBlock(), _createBlock(_component_share_result_button, {
                  key: 0,
                  onOpenResultCard: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-result-card')))
                }))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["onAfterChange"])
    ])
  ]))
}